<template>
  <div class="legal-address-footer">
    {{ props.legalAddress }}
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ legalAddress: string }>()
</script>

<style scoped lang="scss">
.legal-address-footer {
  padding: 24px 16px;
  text-align: center;
  color: var(--color-content-secondary);
  border-top: 1px solid var(--color-border);
  background-color: var(--color-background-primary);
  font-size: 14px;
  line-height: 20px;
}
</style>
